export enum EAccountAuthority {
  ADMIN = 'admin',
  MEMBER = 'member'
}
